module.exports = __webpack_public_path__ + "img/Qualityserve-bac.2db0cded.png";